import React from 'react';
import { IconButton } from 'atoms';

type HeaderActionsProps = {
  onOpenMenu?: () => void;
  isMenuOpen?: boolean;
};

const HeaderActions: React.FC<HeaderActionsProps> = ({
  onOpenMenu,
  isMenuOpen = false,
}) => {
  return (
    <IconButton
      className={isMenuOpen ? 'burger burger--open' : 'burger'}
      aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
      aria-expanded={isMenuOpen}
      icon={<span className="burger-icon" aria-hidden="true" />}
      onClick={onOpenMenu}
    />
  );
};

export default HeaderActions;
